import { validateEnumTranslations } from '../../safety_checks';

/**
 * Parcours d'onboarding servi au pro — le SEUL interrupteur du nouveau parcours (spec
 * « Onboarding Propelsia » v4, section K : livraison derrière un drapeau « nouveaux inscrits »).
 *
 * - `V1` : wizard 4 étapes + tableau de bord avec score (comptes existants, valeur par défaut) ;
 * - `V2` : tunnel obligatoire 6 étapes avant tout accès à l'espace pro, accueil « Et maintenant »,
 *   relances par séquences admin (le moteur `trial_relance` ne touche jamais un compte V2).
 *
 * Posé une fois à l'inscription (`signupProfessional`, env `ONBOARDING_FLOW_V2` ou inscription
 * issue d'un token de quiz) ; jamais modifié ensuite pour un compte donné. Enum dual-defined :
 * colonne `professional.onboarding_flow` (VarChar, valeurs minuscules).
 */
export enum OnboardingFlow {
  V1 = 'v1',
  V2 = 'v2',
}

export const TRANSLATE_KEY_ONBOARDING_FLOW = 'ONBOARDING_FLOW_';

export const OnboardingFlowTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_ONBOARDING_FLOW}${OnboardingFlow.V1}`]: 'Parcours classique (assistant 4 étapes)',
    [`${TRANSLATE_KEY_ONBOARDING_FLOW}${OnboardingFlow.V2}`]: 'Nouveau parcours (tunnel 6 étapes)',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(OnboardingFlow, OnboardingFlowTranslation, TRANSLATE_KEY_ONBOARDING_FLOW, true);
